var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailsBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 609 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Tertiary",
    d: "M0.28418 0.429688H608.284V144.998L0.28418 108.83V0.429688Z",
    fill: "#F39200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Secondary",
    d: "M0.28418 0H608.284V76.568L0.28418 129.32V0Z",
    fill: "#FFBA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Primary",
    d: "M0.284 0H608.284V24L0 132.338L0.284 0Z",
    fill: "#183F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsBottom);
export default __webpack_public_path__ + "static/media/details_bottom.350addd87ea744e65d85c24ae029603a.svg";
export { ForwardRef as ReactComponent };